import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'

export class Solicitud_generica extends Component {
    static displayName = Solicitud_generica.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, termino: "", observacion: "", pao1: "", pao2: "", pae: "", accion: "",loading: false, loading2: false
        };
        this.onInputChange = this.onInputChange.bind(this);  
        this.cambiarSolicitud = this.cambiarSolicitud.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangeRadioAcciones = this.onChangeRadioAcciones.bind(this);
    }

    componentDidMount() {
        this.setState({ 
            observacion: this.props.observacion,
            accion: this.props.accion
        }, () => {
            //console.log("state solicitud_generica :", this.state);
            //console.log("props solicitud_generica :", this.props);
        })
        //console.log(this.state.termino)
    }


    onInputChange(event) {
        //console.log(JSON.stringify(event.target.name))
        var control = event.target.name;
        if (control === "review") {
            //var value = this.state.observacion;
            var value = event.target.value.toUpperCase();
            this.setState({
                observacion: value
            });
        }
        else if (control === "inlineRadioOptions") {
                var value = event.target.value;

                this.setState({
                    pao1: value == 1 ? "1" : "",
                    pao2: value == 2 ? "2" : "",
                    pa3: value == 3 ? "3" : ""
                });
        } else if (control === "inlineRadioAction") {
                    var value = event.target.value;
                    this.setState({
                        accion: value, 
                    });
        }
    }

    //funcion para click en update delete
    handleClick = (text) => {
        //console.log('accion:', text);
        this.setState({
            accion: text,
        });
    }
    onChangeValue(event) {
        this.setState({
            accion: event.target.value,
        });
    }

    // funcion para los radio buttons de update delete
    onChangeRadioAcciones(text) {
        //console.log("onChangeRadioAcciones: ", text);
        this.setState({
            accion: text,
        });
    }

    cambiarSolicitud(event) {
        event.preventDefault(); 

        Swal.fire({
            title: 'Hecho!',
            text: 'Actividad actualizada exitosamente',
            icon: 'success',
            timer: 1500,
            confirmButtonText: 'Ok'

        });
        //console.log('ENVIANDO DES SOLICITUD GENERICA EL CAMMBIO de OBS: ' + this.state.observacion);
        //console.log('AGREEGANDO SOLICITUD[EXPAND]: ' + this.props.idactividad + '|' + this.props.descripcion + '|' + this.props.totalhoras + '|' + this.props.anio + '|' + terminoeval+'|'+ this.props.tipoactividad+'|'+ this.state.observacion+'|'+ this.props.termino1+'|'+ this.props.termino2+'|'+ this.props.termino3+'|'+ this.state.accion)
        this.props.updatestate_solicitud(this.props.rowindex, this.state.observacion, this.state.accion);
        this.props.handleHideClick(this.props.idUnico);
    }

    handlkeyPress(evento) {
        // console.log(String.fromCharCode(event.keyCode));
        let tecla = evento.which;
        let caracter = String.fromCharCode(tecla)
        let regex = new RegExp("^[A-Za-z0-9 ,.]+$");


        if (!regex.test(caracter)) {

            Swal.fire({
                title: 'Lo sentimos!',
                text: 'El campo de observación no permite caracteres especiales.',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })

            return false;
        }

    }

    render() { 
       // console.log(this.props)
        return (
            <div>
                <div className="box2 sb9"><table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className='tr-tablexpand-header'>
                            <th className='tr-descr-header'></th>
                            <th className='tr-obser-header'></th>
                            <th className='tr-perio-header'></th> 
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className='td-descr-header'>Actividad</td>
                            <td className='td-obser-header'>Observación</td>
                            {this.props.accion === 'Nueva Carga' ?
                                <td></td>: <td className='td-perio-header'>Acciones</td>
                            } 
                        </tr>
                        <tr>
                            <td>{this.props.descripcion}</td>
                            <td><textarea id="review" name="review" onKeyPress={this.handlkeyPress}  className='area_width' value={this.state.observacion} onChange={this.onInputChange}>{this.state.observacion}</textarea></td>
                           

                                {this.props.accion==='Nueva Carga'?
                                <td> <div>
                                    <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.cambiarSolicitud}>Actualizar</button>
                                </div></td>
                                :
                                <td><div> {/*onChange={this.onChangeValue}*/}
                                    <ul id="list" className="list-group pb-4">
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Modificar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioModificar" value="0" onChange={() => { this.onChangeRadioAcciones("Modificar Carga") }} />Modificar

                                            {/*<FontAwesomeIcon icon={faEdit} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Modificar Carga")} style={this.state.accion === "Modificar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Modificar*/}
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Eliminar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioEliminar" value="1" onChange={() => { this.onChangeRadioAcciones("Eliminar Carga") }} />Eliminar

                                            {/*<FontAwesomeIcon icon={faTrash} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Eliminar Carga")} style={this.state.accion === "Eliminar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Eliminar*/}
                                        </li>
                                    </ul>
                                    <div>
                                        <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.cambiarSolicitud}>Actualizar</button>
                                    </div>
                                </div></td>
                                }
                                
                             
                        </tr>
                    </tbody>
                </table>





                </div>

            </div>
        );
    }


}
